<template>
  <section id="process" class="hw-section" style="padding-top: 0;">
    <div class="hw-container">
      <p class="hw-kicker">Método</p>
      <h2 class="hw-title">Como trabalhamos</h2>
      <p class="hw-lead">
        Um processo curto e visível. Sabem sempre o que está a ser feito, porquê, e o que vem a seguir.
      </p>
      <div class="hw-process-grid">
        <article class="hw-step" v-for="step in steps" :key="step.n">
          <em>{{ step.n }}</em>
          <h3>{{ step.title }}</h3>
          <p>{{ step.text }}</p>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      steps: [
        {
          n: "01",
          title: "Descoberta",
          text: "Percebemos o problema, as pessoas e o contexto antes de escrever uma linha de código.",
        },
        {
          n: "02",
          title: "Desenho",
          text: "Arquitetura, interface e plano de entrega alinhados convosco, com decisões explícitas.",
        },
        {
          n: "03",
          title: "Desenvolvimento",
          text: "Iterações curtas, código sólido e visibilidade permanente do progresso.",
        },
        {
          n: "04",
          title: "Evolução",
          text: "Lançamos, medimos e continuamos a melhorar o produto depois de estar em produção.",
        },
      ],
    };
  },
};
</script>
